import { render, staticRenderFns } from "./DoctorPolicy.vue?vue&type=template&id=3853d18e&scoped=true"
import script from "./DoctorPolicy.vue?vue&type=script&lang=js"
export * from "./DoctorPolicy.vue?vue&type=script&lang=js"
import style0 from "./DoctorPolicy.vue?vue&type=style&index=0&id=3853d18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3853d18e",
  null
  
)

export default component.exports